<template>
  <div class="container">
    <div @click="CloseDrawer" size="medium" v-if="drawer && curriculumMaterial.subjectId == 1" style=" position: fixed;z-index: 10000; float: left;bottom:0px;right:0px;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        color: white;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        border: 0px;">
      <!--
  <svg style="position: fixed;
    bottom: 10px;
    right: 10px;cursor:pointer;" t="1667367585021" class="icon" viewBox="0 0 1024 1024" version="1.1"
        xmlns="http://www.w3.org/2000/svg" p-id="49889" width="45" height="45">
        <path d="M512 64C264.576 64 64 264.576 64 512s200.576 448 448 448 448-200.576 448-448S759.424 64 512 64z"
          fill="#FF934A" p-id="49890"></path>
        <path
          d="M498.56 519.666a10.668 10.668 0 0 1 0-15.332c21.718-21.126 84.97-82.904 148.374-147.128 14.336-14.516 19.86-35.152 7.744-51.408-4.972-6.654-11.584-14.192-20.352-22.284-11.926-11.014-23.296-18.38-32.768-23.28-15.51-8.02-33.686-3.928-47.766 6.24-110.25 79.572-185.43 165.484-221.802 211.612-15.98 20.29-15.98 47.538 0 67.828 36.372 46.128 111.552 132.04 221.802 211.614 14.08 10.166 32.256 14.256 47.766 6.238 9.472-4.9 20.842-12.266 32.768-23.28 8.768-8.092 15.38-15.63 20.352-22.284 12.116-16.256 6.592-36.892-7.744-51.406-63.404-64.226-126.656-126.004-148.374-147.13z"
          fill="#FFFFFF" p-id="49891"></path>
      </svg>
-->

      <el-image style="width: 45px; height: 45px" src="https://wugecdn.steam.fun/resources/jrcode/back3.png" fit="fit"></el-image>
    </div>

    <el-button @click="CloseDrawer" size="medium" v-if="drawer && curriculumMaterial.subjectId == 2" style="position: fixed;z-index: 10000; float: right;top:8px;right:10px; background: #66b1ff7d;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        color: white;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        border: 0px;">
      <svg t="1665542150306" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2543" width="15" height="15">
        <path d="M1024 505.679012c0-10.835979-4.815991-21.069959-12.039976-27.691946l-403.941211-361.199295c-6.621987-5.417989-14.447972-9.029982-23.477954-9.029982-20.46796 0-36.721928 16.855967-36.721928 37.925926l0 159.529688C238.993533 356.985303 21.069959 591.764844 0 893.366255c1.203998 12.641975 11.437978 22.875955 23.477954 22.875955 4.815991 0 9.631981-1.805996 13.243974-4.213992 0 0 0 0 0 0 53.577895-39.129924 99.329806-68.627866 135.449735-87.891828 87.28983-49.965902 222.739565-89.697825 375.045267-105.951793l0 148.091711c0 21.069959 16.253968 37.925926 36.721928 37.925926 8.427984 0 16.253968-3.611993 22.875955-8.427984l403.941211-361.199295c0 0 0 0 0 0C1019.184009 527.35097 1024 517.11699 1024 505.679012z" p-id="2544" fill="#ffffff"></path>
        <path d="M467.151088 380.463257c-33.711934 6.019988-96.921811 24.681952-139.061728 80.667842-7.223986 9.029982-5.417989 22.875955 3.611993 30.099941 0 0 0 0 0.601999 0 9.029982 7.223986 21.671958 5.417989 28.895944-3.009994 23.477954-28.895944 51.771899-57.189888 111.971781-65.015873 9.631981-1.203998 17.457966-9.631981 17.457966-19.865961l0-3.009994C490.027043 387.687243 478.589065 378.65726 467.151088 380.463257z" p-id="2545" fill="#ffffff"></path>
        <path d="M323.273369 518.320988C322.67137 518.320988 322.67137 518.320988 323.273369 518.320988c-12.039976-6.019988-25.885949 0.601999-28.895944 12.641975-2.407995 9.631981-4.815991 19.865961-6.019988 30.70194-1.805996 12.039976 7.223986 22.875955 19.263962 22.875955l3.611993 0c10.23398 0 18.661964-7.825985 19.263962-17.457966 0.601999-7.825985 1.805996-13.243974 4.213992-24.681952C337.119342 532.768959 331.701352 522.534979 323.273369 518.320988z" p-id="2546" fill="#ffffff"></path>
      </svg>
      返回课程
    </el-button>

    <el-button @click="CloseDrawer" size="medium" v-if="drawer && curriculumMaterial.subjectId == 3" style="position: fixed;z-index: 10000; float: right;top:12px;right:20px; background: #66b1ff7d;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        color: white;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        border: 0px;">
      <svg t="1665542150306" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2543" width="15" height="15">
        <path d="M1024 505.679012c0-10.835979-4.815991-21.069959-12.039976-27.691946l-403.941211-361.199295c-6.621987-5.417989-14.447972-9.029982-23.477954-9.029982-20.46796 0-36.721928 16.855967-36.721928 37.925926l0 159.529688C238.993533 356.985303 21.069959 591.764844 0 893.366255c1.203998 12.641975 11.437978 22.875955 23.477954 22.875955 4.815991 0 9.631981-1.805996 13.243974-4.213992 0 0 0 0 0 0 53.577895-39.129924 99.329806-68.627866 135.449735-87.891828 87.28983-49.965902 222.739565-89.697825 375.045267-105.951793l0 148.091711c0 21.069959 16.253968 37.925926 36.721928 37.925926 8.427984 0 16.253968-3.611993 22.875955-8.427984l403.941211-361.199295c0 0 0 0 0 0C1019.184009 527.35097 1024 517.11699 1024 505.679012z" p-id="2544" fill="#ffffff"></path>
        <path d="M467.151088 380.463257c-33.711934 6.019988-96.921811 24.681952-139.061728 80.667842-7.223986 9.029982-5.417989 22.875955 3.611993 30.099941 0 0 0 0 0.601999 0 9.029982 7.223986 21.671958 5.417989 28.895944-3.009994 23.477954-28.895944 51.771899-57.189888 111.971781-65.015873 9.631981-1.203998 17.457966-9.631981 17.457966-19.865961l0-3.009994C490.027043 387.687243 478.589065 378.65726 467.151088 380.463257z" p-id="2545" fill="#ffffff"></path>
        <path d="M323.273369 518.320988C322.67137 518.320988 322.67137 518.320988 323.273369 518.320988c-12.039976-6.019988-25.885949 0.601999-28.895944 12.641975-2.407995 9.631981-4.815991 19.865961-6.019988 30.70194-1.805996 12.039976 7.223986 22.875955 19.263962 22.875955l3.611993 0c10.23398 0 18.661964-7.825985 19.263962-17.457966 0.601999-7.825985 1.805996-13.243974 4.213992-24.681952C337.119342 532.768959 331.701352 522.534979 323.273369 518.320988z" p-id="2546" fill="#ffffff"></path>
      </svg>
      返回课程
    </el-button>

    <el-row :gutter="15">
      <el-col :span="withCol">
        <div class="course-left">
          <div class="course-left-ppt">
            <!-- :src="webofficeUrl" -->
            <div v-if="curriculumMaterial.eduId != null" id="preview-zone" class="course-view"></div>
            <iframe v-else allowfullscreen="true" class="course-view" :src="ppt_url"></iframe>
          </div>
          <div class="course-left-comment">
            <el-row>
              <el-col :span="18">
                <div class="course-left-comment-title">备课资料</div>
              </el-col>
              <el-col :span="6">
                <div class="course-left-comment-title"></div>
              </el-col>
            </el-row>

            <el-row style="margin-top:10px;">
              <el-col :span="18">
                <div class="course-left-comment-content">
                  <el-tooltip class="item" effect="dark" content="本节课的最终创作效果,课前可给学员演示!" placement="top">
                    <el-link v-if="curriculumMaterial.exampleWorkUrl" type="primary" @click="LookWork('1')" :disabled="curriculumMaterial.exampleWorkUrl == ''">课堂成果<i class="el-icon-video-play el-icon--right"></i>
                    </el-link>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="本节课给学员推送的创作模板,学员基于这个模板开始创作!" placement="top">
                    <el-link type="primary" v-if="curriculumMaterial.teachTemplateUrl" style="margin-left: 20px" @click="LookWork('2')" :disabled="curriculumMaterial.teachTemplateUrl == ''">授课模板<i class="el-icon-help el-icon--right"></i>
                    </el-link>
                  </el-tooltip>

                  <el-tooltip class="item" effect="dark" content="本节课的课后作业模板,学员基于这个模板完成课后作业!" placement="top">
                    <el-link type="primary" v-if="curriculumMaterial.homeTemplateUrl" style="margin-left: 20px" :disabled="curriculumMaterial.homeTemplateUrl == ''" @click="LookWork('3')">作业模板<i class="el-icon-picture-outline-round el-icon--right"></i>
                    </el-link>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="本节课推送给学员的课程讲义,方便学员课后复习!" placement="top">
                    <el-link type="primary" style="margin-left: 20px" @click="LookWork('4')" v-if="curriculumMaterial.stuNoteUrl !== ''">
                      学生讲义<i class="el-icon-document el-icon--right"></i>
                    </el-link>
                  </el-tooltip>
                  <el-tooltip v-if="curriculumMaterial.eduId != null" class="item" effect="dark" content="组装图册" placement="top">
                    <el-link type="primary" v-if="
                        curriculumMaterial.assemblePicture ||
                          curriculumMaterial.assemblePicturePdf
                      " style="margin-left: 20px" @click="LookWorktC">
                      {{
                        curriculumMaterial.assemblePictureState === 1
                          ? '组装图册'
                          : '组装PDF'
                      }}
                      <i class="el-icon-picture-outline-round el-icon--right"></i>
                    </el-link>
                  </el-tooltip>
                  <el-link type="primary" style="margin-left: 20px" @click="LookWork('5')" v-if="video_url">录播课程<i class="el-icon-video-play el-icon--right"></i>
                  </el-link>
                  <span v-if="curriculumMaterial.eduId != null">
                    <span v-if="
                        curriculumMaterial.knowledgePointUrl != null &&
                          curriculumMaterial.knowledgePointUrl != ''
                      ">
                      <span v-for="(item, index) in JSON.parse(
                          curriculumMaterial.knowledgePointUrl
                        )" :key="index">
                        <el-tooltip class="item" effect="dark" content="本节课涉及到的知识点海报,课后可以发送给家长!" placement="top">
                          <el-link type="primary" style="margin-left: 20px" @click="DownloadFile1(item.url)">知识点海报<i class="el-icon-view el-icon--right"></i>
                          </el-link>
                        </el-tooltip>

                        <el-tooltip class="item" effect="dark" content="本节课涉及到的知识点海报,课后可以发送给家长!" placement="top">
                          <el-link type="primary" style="margin-left: 20px" @click="downloadknowledge(item.url)">下载<i class="el-icon-download el-icon--right"></i>
                          </el-link>
                        </el-tooltip>
                      </span>
                    </span>
                  </span>
                  <span v-else-if="other_meterial_url">
                    <el-tooltip class="item" effect="dark" content="本节课涉及到的知识点海报,课后可以发送给家长!" placement="top">
                      <el-link type="primary" style="margin-left: 20px" :disabled="!other_meterial_url" @click="DownloadFile">知识点海报<i class="el-icon-view el-icon--right"></i>
                      </el-link>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="本节课涉及到的知识点海报,课后可以发送给家长!" placement="top">
                      <el-link type="primary" style="margin-left: 20px" @click="downloadknowledge1">下载<i class="el-icon-download el-icon--right"></i>
                      </el-link>
                    </el-tooltip>
                  </span>
                  <span style="display: inline-block;width:0px;overflow: hidden;opacity: 0;float:left">占位</span>
                </div>
              </el-col>

              <el-col :span="6">
                <div v-if="curriculumMaterial.subjectId === 4" style="float: right">
                  <el-button-group style="width: 100%; ">
                    <el-button type="primary" size="small" @click="classroomTopic" :disabled="showType1">课堂题目</el-button>
                    <el-button type="primary" size="small" @click="classroomTopic1" :disabled="showType2">课后题目</el-button>
                  </el-button-group>
                </div>
                <div v-else class="course-left-comment-content">
                  <el-tooltip class="item" effect="dark" content="边备课,边练习!" placement="top">
                    <el-button style="float: right" size="small" type="primary" @click="GoCreateNew">开始创作<i class="el-icon-question el-icon--right"></i></el-button>
                  </el-tooltip>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
      <el-col :span="withCol1">
        <div class="course-right">
          <div v-if="$store.state.user.userInfo.tchShixunAuth">
            <div class="course-right-video" v-if="train_video_url">
              <el-row>
                <el-col :span="24">
                  <div class="course-right-video-title">师训视频</div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="course-right-video-desc">
                    <video id="train_video" class="coursevideo" :src="train_video_url" controls="controls" controlslist="nodownload" :poster="curriculumMaterial.imgUrl">
                      您的浏览器不支持 video 标签。
                    </video>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
          <div v-if="$store.state.user.userInfo.tchKtslAuth">
            <div class="course-right-video1" v-if="exampal_video_url">
              <el-row>
                <el-col :span="24">
                  <div class="course-right-video1-title">课堂实录</div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="course-right-video1-wrapper">
                    <el-row>
                      <el-col :span="24">
                        <div class="videolist">
                          <el-row>
                            <el-col :span="24">
                              <div class="course-right-video1-desc">
                                <video id="example_video" class="coursevideo1" :src="exampal_video_url" controls="controls" :poster="curriculumMaterial.imgUrl">
                                  您的浏览器不支持 video 标签。
                                </video>
                              </div>
                            </el-col>
                          </el-row>
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-drawer :with-header="false" title="组装图册" size="80%" :visible.sync="dialogVisibletc" :direction="direction" :destroy-on-close="true">
      <div v-if="curriculumMaterial.assemblePictureState === 1">
        <mavon-editor v-model="curriculumMaterial.assemblePicture" defaultOpen="preview" :boxShadow="false" :editable="false" :subfield="false" :toolbarsFlag="false"></mavon-editor>
      </div>
      <div v-else-if="curriculumMaterial.assemblePictureState === 2">
        <iframe :src="curriculumMaterial.assemblePicturePdf" frameborder="0" style="width: 100%; height: 100vh; margin: auto; display: block"></iframe>
      </div>
    </el-drawer>
    <el-drawer class="container1" :with-header="false" title="查看项目 (点击右上角X号退出)" size="80%" :visible.sync="dialogVisible" :direction="direction" :destroy-on-close="true">
      <iframe style="width: 100%; height: 100vh" :src="stu_note_url"></iframe>
    </el-drawer>

    <el-dialog title="录播课程" :visible.sync="dialogVisible1" width="840px" top="10vh" append-to-body>
      <el-row style="text-align: center">
        <el-col :span="24">
          <div class="course-right-video-desc">
            <video id="learn_video" style="width: 800px" class="coursevideo" :src="video_url" controls="controls" :poster="curriculumMaterial.imgUrl">
              您的浏览器不支持 video 标签。
            </video>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <el-drawer class="container1" :with-header="false" title="查看项目 (点击右上角X号退出)" size="100%" :visible.sync="drawer" :direction="direction" :destroy-on-close="true">
      <iframe id="iframe_project" width="100%" height="100%" :src="project_url"></iframe>
    </el-drawer>

    <el-drawer class="container1" title="边讲边做 (点击右上角X号退出)" size="100%" :visible.sync="drawer1" :direction="direction" :destroy-on-close="true">
      <iframe id="iframe_project1" width="100%" height="100%" :src="project_url1"></iframe>
    </el-drawer>

    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
      <div>
        <el-button type="primary">新窗口打开</el-button>
        <el-button type="primary">原窗口创作</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PreviewFile from '@/config/preview-oss'
import {
  udpateSchooRemainTraffic,
  getPrepareCurrculumMaterial,
  getTchLesson,
  generateWebofficeToken,
  refreshWebofficeToken,
  tchGetTchCppLessonOjProblemList,
} from '@/api/educational'

import Axios from 'axios'

export default {
  name: 'prepare-ppt',
  props: {
    curriculumMaterial: Object,
    tchPlanId: Number,
  },
  data() {
    return {
      dialogVisibletc: false,
      officeToken: {},
      webofficeUrl: '',
      userId: '',
      userActive: '',
      withCol: '18',
      withCol1: '6',
      realname: '',
      name: '',
      phone_num: '',
      dialogVisible: false,
      ppt_url: '', //课件地址
      lession_plan_url: '', //讲义地址
      train_video_url: '', //师训视频
      exampal_video_url: '', // 课堂实录
      video_url: '', //录播视频
      other_meterial_url: '', //附加资料
      stu_note_url: '', //学生讲义
      dialogVisible1: false, //录播视频开关

      //定时器
      intervalId: null,
      total_buffertime: 0, //缓冲总时长
      last_buffertime: 0, //上次提交总时长

      intervalId_example: null,
      total_buffertime_example: 0, //缓冲总时长
      last_buffertime_example: 0, //上次提交总时长

      intervalId_learn: null,
      total_buffertime_learn: 0, //缓冲总时长
      last_buffertime_learn: 0, //上次提交总时长

      project_url: '',
      project_url1: '',

      drawer: false,
      drawer1: false,
      direction: 'ltr',

      centerDialogVisible: false, //老师开始创作方式
      py_version: '',
      schoolPPt: '',
      //
      NewToken: null,
      showType1: false,
      showType2: false,
    }
  },

  watch: {
    curriculumMaterial() {
      console.log('--------加载课件----------')
      console.log('Watch')

      if (!this.curriculumMaterial.eduId) {
        console.log('平台课件')
        this.ppt_url =
          this.curriculumMaterial.pptUrl +
          '?usercode=' +
          this.$store.state.user.userInfo.code

        console.log('平台师训视频')
        console.log(this.train_video_url)
        this.train_video_url = this.curriculumMaterial.trainVideoUrl
        this.exampal_video_url = this.curriculumMaterial.exampleVideoUrl
        this.other_meterial_url = this.curriculumMaterial.otherMaterialUrl
        this.video_url = this.curriculumMaterial.videoUrl
      } else {
        console.log('校区课件-watch')
        console.log('流量不计算！')

        if (this.curriculumMaterial.pptUrl != '') {
          this.preview_url = JSON.parse(this.curriculumMaterial.pptUrl)[0].url
          let ppt_url1 = JSON.parse(this.curriculumMaterial.pptUrl)[0].url

          //OSS课件资源地址
          this.schoolPPt = 'oss://steamfun/' + ppt_url1.split('com/')[1]

          this.init()
        }

        if (this.curriculumMaterial.trainVideoUrl) {
          this.train_video_url = JSON.parse(
            this.curriculumMaterial.trainVideoUrl
          )[0].url
        }

        if (this.curriculumMaterial.exampleVideoUrl) {
          this.exampal_video_url = JSON.parse(
            this.curriculumMaterial.exampleVideoUrl
          )[0].url
        }

        if (this.curriculumMaterial.videoUrl) {
          this.video_url = JSON.parse(this.curriculumMaterial.videoUrl)[0].url
        }
      }
      // if (!this.train_video_url && !this.exampal_video_url) {
      //   this.withCol1 = '0'
      //   this.withCol = '24'
      // }
    },

    dialogVisible1: function () {
      console.log('录播视频是否打开')
      console.log(this.dialogVisible1)
      if (this.dialogVisible1) {
        //this.dataRefreh_learn();
      } else {
        if (document.getElementById('learn_video')) {
          document.getElementById('learn_video').pause()
        }
      }
    },
  },

  mounted() {
    console.log('备课页面MOUNTED')
    this.tchGetTchCppLessonOjProblemList(1)
    this.tchGetTchCppLessonOjProblemList(2)
    this.userId = this.$store.state.user.userInfo.id
    this.userActive = this.$store.state.user.userInfo.userImageUrl
    this.name = this.$store.state.user.userInfo.name
    this.realname = this.$store.state.user.userInfo.realName
    this.phone_num = this.$store.state.user.userInfo.phoneNum

    //第二次进入时候
    console.log('--------加载课件----------')
    console.log('Watch')

    if (!this.curriculumMaterial.eduId) {
      console.log('平台课件')
      this.ppt_url =
        this.curriculumMaterial.pptUrl +
        '?usercode=' +
        this.$store.state.user.userInfo.code

      console.log('平台师训视频')
      console.log(this.train_video_url)
      this.train_video_url = this.curriculumMaterial.trainVideoUrl
      this.exampal_video_url = this.curriculumMaterial.exampleVideoUrl
      this.other_meterial_url = this.curriculumMaterial.otherMaterialUrl
      this.video_url = this.curriculumMaterial.videoUrl

    } else {
      console.log('校区课件-watch')
      console.log('流量不计算！')

      this.preview_url = JSON.parse(this.curriculumMaterial.pptUrl)[0].url
      let ppt_url1 = JSON.parse(this.curriculumMaterial.pptUrl)[0].url

      //OSS课件资源地址
      this.schoolPPt = 'oss://steamfun/' + ppt_url1.split('com/')[1]

      this.init()

      if (this.curriculumMaterial.trainVideoUrl) {
        this.train_video_url = JSON.parse(
          this.curriculumMaterial.trainVideoUrl
        )[0].url
      }

      if (this.curriculumMaterial.exampleVideoUrl) {
        this.exampal_video_url = JSON.parse(
          this.curriculumMaterial.exampleVideoUrl
        )[0].url
      }

      if (this.curriculumMaterial.videoUrl) {
        this.video_url = JSON.parse(this.curriculumMaterial.videoUrl)[0].url
      }
    }
    this.info()
  },

  destroyed() {
    // 在页面销毁后，清除计时器
    this.clear()
    localStorage.setItem('home_template_url', '')
  },
  methods: {
    tchGetTchCppLessonOjProblemList(type = 1) {
      tchGetTchCppLessonOjProblemList({
        lesson_id: this.$route.query.curriculumMaterial_id,
        type,
      }).then((res) => {
        if (type === 1) {
          this.showType1 = res.cppLessonOjProblemRelationList.length === 0
        }
        if (type === 2) {
          this.showType2 = res.cppLessonOjProblemRelationList.length === 0
        }
      })
    },
    //加载远程的Py代码
    ReadPyCode(url, callback) {
      Axios({
        method: 'get',
        url: url,
        responseType: 'text',
      }).then((res) => {
        callback(res.data)
      })
    },

    LookWorktC() {
      console.log(1245)
      this.dialogVisibletc = true
    },

    getImageSize(url) {
      return new Promise((resolve, reject) => {
        let img = new Image()
        img.onload = function () {
          resolve({ width: img.width, height: img.height })
        }
        img.onerror = function () {
          reject(new Error('Failed to load image'))
        }
        img.src = url
      })
    },

    getUrlBase64(url) {
      return new Promise((resolve) => {
        let canvas = document.createElement('canvas')
        let ctx = canvas.getContext('2d')
        let img = new Image()
        img.crossOrigin = 'Anonymous' //允许跨域
        img.src = url

        var that = this

        img.onload = async function () {
          let imageSize = await that.getImageSize(url)
          canvas.height = imageSize.height
          canvas.width = imageSize.width
          ctx.drawImage(img, 0, 0, imageSize.width, imageSize.height)
          let dataURL = canvas.toDataURL('image/png')
          canvas = null
          resolve(dataURL)
        }
      })
    },

    downloadknowledge(val) {
      console.log('下载校区知识点海报')
      this.getUrlBase64(val).then((base64) => {
        let link = document.createElement('a')
        link.href = base64
        link.download = this.curriculumMaterial.title + '.png'
        link.click()
      })
    },

    downloadknowledge1() {
      this.getUrlBase64(this.curriculumMaterial.otherMaterialUrl).then(
        (base64) => {
          let link = document.createElement('a')
          link.href = base64
          link.download = this.curriculumMaterial.title + '.png'
          link.click()
        }
      )
    },
    //定时刷新Weboffice凭证
    //获取Weboffice凭证
    init() {
      generateWebofficeToken({
        Id: this.userId,
        Name: this.realname,
        Avatar: this.userActive,
        SourceURI: this.schoolPPt,
      }).then((res) => {
        console.log('OSS凭证')
        this.officeToken = res.result
        this.$nextTick(() => {
          this.preview1(this.officeToken)
        })
      })
    },

    //初始化课件预览
    preview1(officeToken) {
      let mount = document.getElementById('preview-zone')
      let instance = window.aliyun.config({
        mount,
        refreshToken: this.refreshTokenPromise, // Token过期自动刷新。
        url:
          officeToken.PreviewURL ||
          officeToken.EditURL ||
          officeToken.WebofficeURL ||
          officeToken.WebofficeUrl,
        mode: 'simple',
        // 不提示缺失字体
        wordOptions: {
          font: {
            showMissingAlert: false,
          },
        },
        // 不显示保存成功中的历史版本链接
        commonOptions: {
          showHistoryLinkInSavingToast: false,
        },

        //隐藏组件
        commandBars: [
          //右下角浮动帮助按钮
          {
            cmbId: 'FloatQuickHelp', // 组件ID。
            attributes: {
              visible: false, // 隐藏组件。
              enable: false, // 禁用组件（组件显示但不响应单击事件）。
            },
          },
          {
            cmbId: 'HeaderLeft', // 组件ID。
            attributes: {
              visible: false, // 隐藏组件。
              enable: false, // 禁用组件（组件显示但不响应单击事件）。
            },
          },
          {
            cmbId: 'HeaderRight', // 组件ID。
            attributes: {
              visible: false, // 隐藏组件。
              enable: false, // 禁用组件（组件显示但不响应单击事件）。
            },
          },
          {
            cmbId: 'TabInsertTab', // 组件ID。
            attributes: {
              visible: false, // 隐藏组件。
              enable: false, // 禁用组件（组件显示但不响应单击事件）。
            },
          },
          {
            cmbId: 'TabViewTab', // 组件ID。
            attributes: {
              visible: false, // 隐藏组件。
              enable: false, // 禁用组件（组件显示但不响应单击事件）。
            },
          },
          {
            cmbId: 'TabReviewTab', // 组件ID。
            attributes: {
              visible: false, // 隐藏组件。
              enable: false, // 禁用组件（组件显示但不响应单击事件）。
            },
          },
          {
            cmbId: 'DownloadImg', // 组件ID。
            attributes: {
              visible: false, // 隐藏组件。
              enable: false, // 禁用组件（组件显示但不响应单击事件）。
            },
          },
          {
            cmbId: 'ToolBarFullScreenBtn', // 组件ID。
            attributes: {
              visible: false, // 隐藏组件。
              enable: false, // 禁用组件（组件显示但不响应单击事件）。
            },
          },
          {
            cmbId: 'Comment', // 组件ID。
            attributes: {
              visible: false, // 隐藏组件。
              enable: false, // 禁用组件（组件显示但不响应单击事件）。
            },
          },
        ],
      })

      instance.setToken({
        token: officeToken.AccessToken,
        timeout: 25 * 60 * 1000, // Token过期时间，单位为ms。25分钟之后刷新Token。
      })

      instance.on('fileOpen', function (data) {
        console.log(data)
      })

      instance.on('error', (err) => {
        console.log('发生错误：', err)
      })
    },
    //定时刷新TOKEN
    refreshTokenPromise() {
      this.NewToken = setInterval(() => {
        refreshWebofficeToken({
          AccessToken: this.officeToken.AccessToken,
          RefreshToken: this.officeToken.RefreshToken,
        }).then((res) => {
          this.officeToken = res.result
          console.log(this.officeToken, 666666)
        })
      }, 1200000)
    },

    info() {
      console.log('检测教师是否有师训视频权限')
      console.log(this.$store.state.user.userInfo.tchShixunAuth)
      console.log(this.$store.state.user.userInfo.tchKtslAuth)
      //tch_shixun_auth 师训视频权限
      //tch_ktsl_auth 课堂实录权限
      if (
        !this.$store.state.user.userInfo.tchShixunAuth &&
        !this.$store.state.user.userInfo.tchKtslAuth
      ) {
        this.withCol1 = '0'
        this.withCol = '24'
      } else {
        this.withCol1 = '6'
        this.withCol = '18'
      }
    },
    CloseDrawer() {
      console.log('返回课程')

      this.$confirm('确定要返回课程吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.drawer = false
      })
    },

    //教师端获得教师c++课程对应的题目列表
    classroomTopic() {
      this.cpp_url =
        '/cpp?' +
        '&lesson_id=' +
        this.curriculumMaterial.id +
        '&userType=' +
        'tch' +
        '&type=' +
        '1' +
        '&title=' +
        this.curriculumMaterial.title
      console.log(this.curriculumMaterial.title, 4547)
      sessionStorage.setItem('lecturesTitle', this.curriculumMaterial.title)
      sessionStorage.setItem('sbj', '4')

      window.open(this.cpp_url, '_blank')
    },
    classroomTopic1() {
      this.cpp_url =
        '/cpp?' +
        '&lesson_id=' +
        this.curriculumMaterial.id +
        '&userType=' +
        'tch' +
        '&type=' +
        '2' +
        '&title=' +
        this.curriculumMaterial.title
      console.log(this.curriculumMaterial.title, 4547)
      sessionStorage.setItem('lecturesTitle', this.curriculumMaterial.title)
      sessionStorage.setItem('sbj', '4')

      window.open(this.cpp_url, '_blank')
    },

    compileStr(code) {
      //对字符串进行加密
      var c = String.fromCharCode(code.charCodeAt(0) + code.length)
      for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1))
      }
      return escape(c)
    },

    //字符串进行解密
    uncompileStr(code) {
      code = unescape(code)
      var c = String.fromCharCode(code.charCodeAt(0) - code.length)
      for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1))
      }
      return c
    },

    GoCreateNew() {
      if (this.curriculumMaterial.subjectId == '3') {
        console.log('创作演示')
        var that_3_1 = this
        if (this.tchPlanId) {
          console.log('老师课堂创作')

          this.getTchLesson(function (res) {
            console.log('老师课堂作品创作')
            console.log(res)

            if (res) {
              console.log('老师创作过作品')

              if (localStorage.getItem('current_py_version') == 'v2') {
                that_3_1.project_url1 =
                  '/python/teachpy_v2?type=2&title=' +
                  res.title +
                  '&lessonId=' +
                  that_3_1.curriculumMaterial.id +
                  '&tchPlanId=' +
                  that_3_1.tchPlanId +
                  '&work_id=' +
                  res.id +
                  '&mode=3'

                that_3_1.$store.commit('SET_TEACH_WORK_URL', res.work_url || '') //老师的课堂作品
                that_3_1.$store.commit(
                  'SET_HOME_TEMPLATE_URL',
                  that_3_1.curriculumMaterial.homeTemplateUrl || ''
                )
                window.open(that_3_1.project_url1, '_blank')
              } else if (localStorage.getItem('current_py_version') == 'v1') {
                that_3_1.project_url1 =
                  '/python/teachpy?type=2&title=' +
                  res.title +
                  '&lessonId=' +
                  that_3_1.curriculumMaterial.id +
                  '&tchPlanId=' +
                  that_3_1.tchPlanId +
                  '&work_id=' +
                  res.id +
                  '&mode=3'

                that_3_1.$store.commit('SET_TEACH_WORK_URL', res.work_url || '') //老师的课堂作品
                that_3_1.$store.commit(
                  'SET_HOME_TEMPLATE_URL',
                  that_3_1.curriculumMaterial.homeTemplateUrl || ''
                )
                window.open(that_3_1.project_url1, '_blank')
              } else {
                that_3_1.project_url1 =
                  '/python/teachpy_v2?type=2&title=' +
                  res.title +
                  '&lessonId=' +
                  that_3_1.curriculumMaterial.id +
                  '&tchPlanId=' +
                  that_3_1.tchPlanId +
                  '&work_id=' +
                  res.id +
                  '&mode=3'

                that_3_1.$store.commit('SET_TEACH_WORK_URL', res.work_url || '') //老师的课堂作品
                that_3_1.$store.commit(
                  'SET_HOME_TEMPLATE_URL',
                  that_3_1.curriculumMaterial.homeTemplateUrl || ''
                )
                window.open(that_3_1.project_url1, '_blank')
              }
            } else {
              console.log('老师没有创作过作品')
              console.log('判断系统版本')
              console.log(localStorage.getItem('current_py_version'))

              if (localStorage.getItem('current_py_version') == 'v2') {
                that_3_1.project_url1 =
                  '/python/teachpy_v2?type=2&title=' +
                  that_3_1.curriculumMaterial.title +
                  '&lessonId=' +
                  that_3_1.curriculumMaterial.id +
                  '&tchPlanId=' +
                  that_3_1.tchPlanId +
                  '&mode=3'

                that_3_1.$store.commit(
                  'SET_TEACH_WORK_URL',
                  that_3_1.curriculumMaterial.teachTemplateUrl || ''
                ) //老师的课堂作品
                that_3_1.$store.commit(
                  'SET_HOME_TEMPLATE_URL',
                  that_3_1.curriculumMaterial.homeTemplateUrl || ''
                )
                window.open(that_3_1.project_url1, '_blank')
              } else if (localStorage.getItem('current_py_version') == 'v1') {
                that_3_1.project_url1 =
                  '/python/teachpy?type=2&title=' +
                  that_3_1.curriculumMaterial.title +
                  '&lessonId=' +
                  that_3_1.curriculumMaterial.id +
                  '&tchPlanId=' +
                  that_3_1.tchPlanId +
                  '&mode=3'

                that_3_1.$store.commit(
                  'SET_TEACH_WORK_URL',
                  that_3_1.curriculumMaterial.teachTemplateUrl || ''
                ) //老师的课堂作品
                that_3_1.$store.commit(
                  'SET_HOME_TEMPLATE_URL',
                  that_3_1.curriculumMaterial.homeTemplateUrl || ''
                )
                window.open(that_3_1.project_url1, '_blank')
              } else {
                that_3_1.project_url1 =
                  '/python/teachpy_v2?type=2&title=' +
                  that_3_1.curriculumMaterial.title +
                  '&lessonId=' +
                  that_3_1.curriculumMaterial.id +
                  '&tchPlanId=' +
                  that_3_1.tchPlanId +
                  '&mode=3'

                that_3_1.$store.commit(
                  'SET_TEACH_WORK_URL',
                  that_3_1.curriculumMaterial.teachTemplateUrl || ''
                ) //老师的课堂作品
                that_3_1.$store.commit(
                  'SET_HOME_TEMPLATE_URL',
                  that_3_1.curriculumMaterial.homeTemplateUrl || ''
                )
                window.open(that_3_1.project_url1, '_blank')
              }
            }
          })
        } else {
          console.log('老师备课创作')

          this.getTchLesson(function (res) {
            console.log('老师备课创作')
            console.log(res)

            if (res) {
              console.log('老师创作过作品')

              if (localStorage.getItem('current_py_version') == 'v2') {
                that_3_1.project_url1 =
                  '/python/teachpy_v2?type=2&title=' +
                  res.title +
                  '&lessonId=' +
                  that_3_1.curriculumMaterial.id +
                  '&work_id=' +
                  res.id +
                  '&mode=2'

                that_3_1.$store.commit('SET_TEACH_WORK_URL', res.work_url || '') //老师的课堂作品
                that_3_1.$store.commit(
                  'SET_HOME_TEMPLATE_URL',
                  that_3_1.curriculumMaterial.homeTemplateUrl || ''
                )
                window.open(that_3_1.project_url1, '_blank')
              } else if (localStorage.getItem('current_py_version') == 'v1') {
                that_3_1.project_url1 =
                  '/python/teachpy?type=2&title=' +
                  res.title +
                  '&lessonId=' +
                  that_3_1.curriculumMaterial.id +
                  '&work_id=' +
                  res.id +
                  '&mode=2'

                that_3_1.$store.commit('SET_TEACH_WORK_URL', res.work_url || '') //老师的课堂作品
                that_3_1.$store.commit(
                  'SET_HOME_TEMPLATE_URL',
                  that_3_1.curriculumMaterial.homeTemplateUrl || ''
                )
                window.open(that_3_1.project_url1, '_blank')
              } else {
                that_3_1.project_url1 =
                  '/python/teachpy_v2?type=2&title=' +
                  res.title +
                  '&lessonId=' +
                  that_3_1.curriculumMaterial.id +
                  '&work_id=' +
                  res.id +
                  '&mode=2'

                that_3_1.$store.commit('SET_TEACH_WORK_URL', res.work_url || '') //老师的课堂作品
                that_3_1.$store.commit(
                  'SET_HOME_TEMPLATE_URL',
                  that_3_1.curriculumMaterial.homeTemplateUrl || ''
                )
                window.open(that_3_1.project_url1, '_blank')
              }
            } else {
              console.log('老师没有创作过作品')

              if (localStorage.getItem('current_py_version') == 'v2') {
                that_3_1.project_url1 =
                  '/python/teachpy_v2?type=2&title=' +
                  that_3_1.curriculumMaterial.title +
                  '&lessonId=' +
                  that_3_1.curriculumMaterial.id +
                  '&mode=2'

                that_3_1.$store.commit(
                  'SET_TEACH_WORK_URL',
                  that_3_1.curriculumMaterial.teachTemplateUrl || ''
                ) //老师的课堂作品
                that_3_1.$store.commit(
                  'SET_HOME_TEMPLATE_URL',
                  that_3_1.curriculumMaterial.homeTemplateUrl || ''
                )
                window.open(that_3_1.project_url1, '_blank')
              } else if (localStorage.getItem('current_py_version') == 'v1') {
                that_3_1.project_url1 =
                  '/python/teachpy?type=2&title=' +
                  that_3_1.curriculumMaterial.title +
                  '&lessonId=' +
                  that_3_1.curriculumMaterial.id +
                  '&mode=2'

                that_3_1.$store.commit(
                  'SET_TEACH_WORK_URL',
                  that_3_1.curriculumMaterial.teachTemplateUrl || ''
                ) //老师的课堂作品
                that_3_1.$store.commit(
                  'SET_HOME_TEMPLATE_URL',
                  that_3_1.curriculumMaterial.homeTemplateUrl || ''
                )
                window.open(that_3_1.project_url1, '_blank')
              } else {
                that_3_1.project_url1 =
                  '/python/teachpy_v2?type=2&title=' +
                  that_3_1.curriculumMaterial.title +
                  '&lessonId=' +
                  that_3_1.curriculumMaterial.id +
                  '&mode=2'

                that_3_1.$store.commit(
                  'SET_TEACH_WORK_URL',
                  that_3_1.curriculumMaterial.teachTemplateUrl || ''
                ) //老师的课堂作品
                that_3_1.$store.commit(
                  'SET_HOME_TEMPLATE_URL',
                  that_3_1.curriculumMaterial.homeTemplateUrl || ''
                )
                window.open(that_3_1.project_url1, '_blank')
              }
            }
          })
        }
      } else if (this.curriculumMaterial.subjectId == '2') {
        console.log('Scratch创作演示')

        var that_2_1 = this

        if (this.tchPlanId) {
          this.getTchLesson(function (res) {
            console.log('老师课堂作品创作')
            console.log(res)

            if (res) {
              console.log('老师创作过作品')

              that_2_1.project_url1 =
                '/scratch/teachsc.html?workurl=' +
                that_2_1.compileStr(res.work_url).replace(/%/g, '%25') +
                '&workname=' +
                res.title +
                '&lessonId=' +
                that_2_1.curriculumMaterial.id +
                '&tchPlanId=' +
                that_2_1.tchPlanId +
                '&work_id=' +
                res.id +
                '&mode=3'

              window.open(that_2_1.project_url1, '_blank')

              //that_2_1.drawer1 = true;
            } else {
              console.log('老师没有做过作品')

              that_2_1.getPrepareCurrculumMaterial(function (res) {
                console.log('检测资料返回')
                console.log(res)
                if (res.classWorkUrl) {
                  console.log('基于模板创作')
                  //空模板
                  that_2_1.project_url1 =
                    '/scratch/teachsc.html?workurl=' +
                    that_2_1
                      .compileStr(res.classWorkUrl)
                      .replace(/%/g, '%25') +
                    '&workname=' +
                    res.classTitle +
                    '&lessonId=' +
                    that_2_1.curriculumMaterial.id +
                    '&tchPlanId=' +
                    that_2_1.tchPlanId +
                    '&mode=3' //mode 1 修改模板 2保存备课趮 3保存课堂作品

                  window.open(that_2_1.project_url1, '_blank')
                } else {
                  console.log('无自定义模板')
                  //空模板
                  that_2_1.project_url1 =
                    '/scratch/teachsc.html?workurl=' +
                    that_2_1
                      .compileStr(
                        that_2_1.curriculumMaterial.teachTemplateUrl
                      )
                      .replace(/%/g, '%25') +
                    '&workname=' +
                    that_2_1.curriculumMaterial.title +
                    '&lessonId=' +
                    that_2_1.curriculumMaterial.id +
                    '&tchPlanId=' +
                    that_2_1.tchPlanId +
                    '&mode=3'

                  window.open(that_2_1.project_url1, '_blank')
                }
              })
            }
          })
        } else {
          console.log('老师备课页面创作-SC')

          this.getTchLesson(function (res) {
            console.log('老师备课作品查询')
            console.log(res)

            if (res) {
              console.log('老师创作过作品')

              that_2_1.project_url1 =
                '/scratch/teachsc.html?workurl=' +
                that_2_1.compileStr(res.work_url).replace(/%/g, '%25') +
                '&workname=' +
                res.title +
                '&lessonId=' +
                that_2_1.curriculumMaterial.id +
                '&work_id=' +
                res.id +
                '&mode=2'

              window.open(that_2_1.project_url1, '_blank')
            } else {
              console.log('老师没有做过作品')

              //空模板
              that_2_1.project_url1 =
                '/scratch/teachsc.html?workurl=' +
                that_2_1
                  .compileStr(that_2_1.curriculumMaterial.teachTemplateUrl)
                  .replace(/%/g, '%25') +
                '&workname=' +
                that_2_1.curriculumMaterial.title +
                '&lessonId=' +
                that_2_1.curriculumMaterial.id +
                '&mode=2'

              window.open(that_2_1.project_url1, '_blank')
            }
          })
        }
      } else if (this.curriculumMaterial.subjectId == '1') {
        var that_1_2 = this
        if (this.tchPlanId) {
          this.getTchLesson(function (res) {
            console.log('老师课堂作品返回')
            console.log(res)

            if (res) {
              console.log('老师做过作品')
              that_1_2.project_url1 =
                '/jrcode/teachjrwork.html?mode=edit&filepath=' +
                res.work_url +
                '&lessonId=' +
                that_1_2.curriculumMaterial.id +
                '&work_id=' +
                res.id +
                '&tchPlanId=' +
                that_1_2.tchPlanId +
                '&role=teach&type=2'
              window.open(that_1_2.project_url1, '_blank')
            } else {
              console.log('老师没有作品')
              that_1_2.getPrepareCurrculumMaterial(function (res) {
                console.log('检测资料返回')
                console.log(res)
                if (res.classWorkUrl) {
                  console.log('有自定义模板')
                  //空模板
                  that_1_2.project_url1 =
                    '/jrcode/teachjrwork.html?mode=edit&filepath=' +
                    res.classWorkUrl +
                    '&lessonId=' +
                    that_1_2.curriculumMaterial.id +
                    '&tchPlanId=' +
                    that_1_2.tchPlanId +
                    '&role=teach&type=2'
                  window.open(that_1_2.project_url1, '_blank')
                } else {
                  console.log('无自定义模板')
                  //空模板
                  that_1_2.project_url1 =
                    '/jrcode/teachjrwork.html?mode=edit&filepath=' +
                    that_1_2.curriculumMaterial.teachTemplateUrl +
                    '&lessonId=' +
                    that_1_2.curriculumMaterial.id +
                    '&tchPlanId=' +
                    that_1_2.tchPlanId +
                    '&role=teach&type=2'
                  window.open(that_1_2.project_url1, '_blank')
                }
              })
            }
          })
        } else {
          console.log('JR老师纯备课保存作品')

          this.getTchLesson(function (res) {
            console.log('老师纯备课作品查询返回')
            console.log(res)

            if (res) {
              console.log('老师做过作品')
              that_1_2.project_url1 =
                '/jrcode/teachjrwork.html?mode=edit&filepath=' +
                res.work_url +
                '&lessonId=' +
                that_1_2.curriculumMaterial.id +
                '&work_id=' +
                res.id +
                '&role=teach&type=1'
              window.open(that_1_2.project_url1, '_blank')
            } else {
              console.log('老师没有作品')

              //空模板
              that_1_2.project_url1 =
                '/jrcode/teachjrwork.html?mode=edit&filepath=' +
                that_1_2.curriculumMaterial.teachTemplateUrl +
                '&lessonId=' +
                that_1_2.curriculumMaterial.id +
                '&role=teach&type=1'
              window.open(that_1_2.project_url1, '_blank')
            }
          })
        }
      }
    },
    // 停止定时器
    clear() {
      clearInterval(this.intervalId) //清除计时器
      clearInterval(this.intervalId_example) //清除计时器
      clearInterval(this.intervalId_learn) //清除计时器
      clearInterval(this.NewToken) //清除计时器

      this.intervalId = null //设置为null
      this.intervalId_example = null
      this.intervalId_learn = null
      this.NewToken = null
    },

    //更新学校剩余流量
    udpateSchooRemainTraffic() {
      console.log('提交的流量')
      console.log(this.cost_num.toFixed(0))

      if (this.cost_num.toFixed(0) == 0) {
        console.log('本次无缓存')
        return
      }

      udpateSchooRemainTraffic({
        cost_num: this.cost_num.toFixed(0),
        type: this.type,
        lession_id: this.curriculumMaterial.id,
      }).then((res) => {
        console.log('更新学校剩余流量')
        console.log(res)
        if (res.is_update) {
          //  this.$message.success("流量充足可以查看");

          if (this.type == '1' || this.type == '2' || this.type == '3') {
            var _that = this
            console.log(_that.preview_url, 121213333)

            PreviewFile(_that.preview_url, function (res) {
              console.log('PPT预览地址-watch')
              console.log(res, 121213333)

              console.log(res)

              if (_that.type == '1') {
                _that.ppt_url = res
              } else if (_that.type == '3') {
                _that.stu_note_url = res
              }
            })
          } else if (this.type == '5') {
            this.last_buffertime = this.total_buffertime
          }
        }

        if (res.msg == '超出学校剩余流量') {
          this.$message.warning('学校剩余流量不足')
          this.$router.go(-1) //返回上一层
        }
      })
    },

    //更新课堂实录流量
    udpateSchooRemainTraffic_example() {
      console.log('提交的流量')
      console.log(this.cost_num_example.toFixed(0))

      if (this.cost_num_example.toFixed(0) == 0) {
        console.log('课堂实录-本次无缓存')
        return
      }

      udpateSchooRemainTraffic({
        cost_num: this.cost_num_example.toFixed(0),
        type: '6',
        lession_id: this.curriculumMaterial.id,
      }).then((res) => {
        console.log('更新学校剩余流量')
        console.log(res)
        if (res.is_update) {
          //  this.$message.success("流量充足可以查看");

          this.last_buffertime_example = this.total_buffertime_example
        }

        if (res.msg == '超出学校剩余流量') {
          this.$message.warning('学校剩余流量不足')
          this.$router.go(-1) //返回上一层
        }
      })
    },

    //更新课堂实录流量
    udpateSchooRemainTraffic_learn() {
      console.log('提交的流量')
      console.log(this.cost_num_learn.toFixed(0))

      if (this.cost_num_learn.toFixed(0) == 0) {
        console.log('录播视频-本次无缓存')
        return
      }

      udpateSchooRemainTraffic({
        cost_num: this.cost_num_learn.toFixed(0),
        type: '4',
        lession_id: this.curriculumMaterial.id,
      }).then((res) => {
        console.log('更新学校剩余流量')
        console.log(res)
        if (res.is_update) {
          //  this.$message.success("流量充足可以查看");

          this.last_buffertime_learn = this.total_buffertime_learn
        }

        if (res.msg == '超出学校剩余流量') {
          this.$message.warning('学校剩余流量不足')
          this.$router.go(-1) //返回上一层
        }
      })
    },

    LookWork(cmd) {
      console.log('查看课堂成果')
      console.log(this.curriculumMaterial, 4545)
      console.log(cmd)

      if (this.curriculumMaterial.subjectId == 1) {
        if (cmd == '1') {
          var that_1_1 = this
          if (this.tchPlanId) {
            this.getPrepareCurrculumMaterial(function (res) {
              console.log('JR课堂成果资料返回')
              console.log(res)

              if (res.exampleWorkUrl) {
                console.log(1254)

                //课后作业
                that_1_1.project_url =
                  '/jrcode/teachjr.html?mode=edit&filepath=' +
                  res.exampleWorkUrl +
                  '&operate=3' +
                  '&tchPlanId=' +
                  that_1_1.tchPlanId +
                  '&role=teach&type=3'
                that_1_1.drawer = true
              } else {
                console.log(456)

                //课后作业
                that_1_1.project_url =
                  '/jrcode/teachjr.html?mode=edit&filepath=' +
                  that_1_1.curriculumMaterial.exampleWorkUrl +
                  '&operate=3' +
                  '&tchPlanId=' +
                  that_1_1.tchPlanId +
                  '&role=teach&type=3'
                that_1_1.drawer = true
              }
            })
          } else {
            //完整作品
            this.project_url =
              '/jrcode/teachjr.html?mode=edit&filepath=' +
              this.curriculumMaterial.exampleWorkUrl +
              '&role=teach' +
              '&type=6'
            this.drawer = true
          }
        } else if (cmd == '2') {
          var that_1_2 = this
          if (this.tchPlanId) {
            this.getPrepareCurrculumMaterial(function (res) {
              console.log('检测资料返回')
              console.log(res)
              if (res.classWorkUrl) {
                console.log('有自定义模板')
                //空模板
                that_1_2.project_url =
                  '/jrcode/teachjr.html?mode=edit&filepath=' +
                  res.classWorkUrl +
                  '&operate=1' +
                  '&tchPlanId=' +
                  that_1_2.tchPlanId +
                  '&role=teach&type=3'
                that_1_2.drawer = true
              } else {
                console.log('无自定义模板')
                //空模板
                that_1_2.project_url =
                  '/jrcode/teachjr.html?mode=edit&filepath=' +
                  that_1_2.curriculumMaterial.teachTemplateUrl +
                  '&operate=1' +
                  '&tchPlanId=' +
                  that_1_2.tchPlanId +
                  '&role=teach&type=3'
                that_1_2.drawer = true
              }
            })
          } else {
            this.project_url =
              '/jrcode/teachjr.html?mode=edit&filepath=' +
              this.curriculumMaterial.teachTemplateUrl +
              '&role=teach' +
              '&type=6'
            this.drawer = true
          }
        } else if (cmd == '3') {
          var that_1_3 = this
          if (this.tchPlanId) {
            this.getPrepareCurrculumMaterial(function (res) {
              console.log('JR课后作业资料返回')
              console.log(res)

              if (res.homeworkWorkUrl) {
                //课后作业
                that_1_3.project_url =
                  '/jrcode/teachjr.html?mode=edit&filepath=' +
                  res.homeworkWorkUrl +
                  '&operate=2' +
                  '&tchPlanId=' +
                  that_1_3.tchPlanId +
                  '&role=teach&type=3'
                that_1_3.drawer = true
              } else {
                //课后作业
                that_1_3.project_url =
                  '/jrcode/teachjr.html?mode=edit&filepath=' +
                  that_1_3.curriculumMaterial.homeTemplateUrl +
                  '&operate=2' +
                  '&tchPlanId=' +
                  that_1_3.tchPlanId +
                  '&role=teach&type=3'
                that_1_3.drawer = true
              }
            })
          } else {
            //课后作业
            this.project_url =
              '/jrcode/teachjr.html?mode=edit&filepath=' +
              this.curriculumMaterial.homeTemplateUrl +
              '&role=teach' +
              '&type=6'
            this.drawer = true
          }
        }
      } else if (this.curriculumMaterial.subjectId == 2) {
        if (cmd == '1') {
          //完整版

          var that_1 = this

          if (this.tchPlanId) {
            this.getPrepareCurrculumMaterial(function (res) {
              console.log('检测资料返回')
              console.log(res)

              if (res.exampleWorkUrl) {
                console.log('有自定义模板')
                //空模板
                that_1.project_url =
                  '/scratch/teachsc.html?workurl=' +
                  that_1.compileStr(res.exampleWorkUrl).replace(/%/g, '%25') +
                  '&workname=' +
                  res.exampalTitle +
                  '&type=3&mode=1' +
                  '&tchPlanId=' +
                  that_1.tchPlanId

                that_1.drawer = true
              } else {
                console.log('无自定义模板')
                //空模板
                that_1.project_url =
                  '/scratch/teachsc.html?workurl=' +
                  that_1
                    .compileStr(that_1.curriculumMaterial.exampleWorkUrl)
                    .replace(/%/g, '%25') +
                  '&workname=' +
                  that_1.curriculumMaterial.title +
                  '&type=3&mode=1' +
                  '&tchPlanId=' +
                  that_1.tchPlanId

                that_1.drawer = true
              }
            })
          } else {
            console.log('老师纯备课-SC')
            //空模板
            this.project_url =
              '/scratch/teachsc.html?workurl=' +
              this.compileStr(this.curriculumMaterial.exampleWorkUrl).replace(
                /%/g,
                '%25'
              ) +
              '&workname=' +
              this.curriculumMaterial.title

            that_1.drawer = true
          }
        } else if (cmd == '2') {
          var that_2 = this

          if (this.tchPlanId) {
            this.getPrepareCurrculumMaterial(function (res) {
              console.log('检测资料返回')
              console.log(res)
              if (res.classWorkUrl) {
                console.log('有自定义模板')
                //空模板
                that_2.project_url =
                  '/scratch/teachsc.html?workurl=' +
                  that_2.compileStr(res.classWorkUrl).replace(/%/g, '%25') +
                  '&workname=' +
                  res.classTitle +
                  '&type=1&mode=1' +
                  '&tchPlanId=' +
                  that_2.tchPlanId

                that_2.drawer = true
              } else {
                console.log('无自定义模板')
                //空模板
                that_2.project_url =
                  '/scratch/teachsc.html?workurl=' +
                  that_2
                    .compileStr(that_2.curriculumMaterial.teachTemplateUrl)
                    .replace(/%/g, '%25') +
                  '&workname=' +
                  that_2.curriculumMaterial.title +
                  '&type=1&mode=1' +
                  '&tchPlanId=' +
                  that_2.tchPlanId

                that_2.drawer = true
              }
            })
          } else {
            console.log('无自定义模板')
            //空模板
            this.project_url =
              '/scratch/teachsc.html?workurl=' +
              this.compileStr(
                this.curriculumMaterial.teachTemplateUrl
              ).replace(/%/g, '%25') +
              '&workname=' +
              this.curriculumMaterial.title

            that_2.drawer = true
          }
        } else if (cmd == '3') {
          var that_3 = this
          if (this.tchPlanId) {
            this.getPrepareCurrculumMaterial(function (res) {
              console.log('检测资料返回')
              console.log(res)

              if (res.homeworkWorkUrl) {
                //课后作业
                that_3.project_url =
                  '/scratch/teachsc.html?workurl=' +
                  that_3
                    .compileStr(res.homeworkWorkUrl)
                    .replace(/%/g, '%25') +
                  '&workname=' +
                  res.homeworkTitle +
                  '&type=2&mode=1' +
                  '&tchPlanId=' +
                  that_3.tchPlanId
                that_3.drawer = true
              } else {
                //课后作业
                that_3.project_url =
                  '/scratch/teachsc.html?workurl=' +
                  that_3
                    .compileStr(that_3.curriculumMaterial.homeTemplateUrl)
                    .replace(/%/g, '%25') +
                  '&workname=' +
                  that_3.curriculumMaterial.title +
                  '&type=2&mode=1' +
                  '&tchPlanId=' +
                  that_3.tchPlanId
                that_3.drawer = true
              }
            })
          } else {
            //课后作业
            this.project_url =
              '/scratch/teachsc.html?workurl=' +
              this.compileStr(
                this.curriculumMaterial.homeTemplateUrl
              ).replace(/%/g, '%25') +
              '&workname=' +
              this.curriculumMaterial.title
            this.drawer = true
          }
        }
      } else if (this.curriculumMaterial.subjectId == 3) {
        if (this.curriculumMaterial.eduId !== null) {
          console.log('校区自定义Py课程')

          if (cmd == '1') {
            console.log('课堂成果')

            if (this.curriculumMaterial.exampleWorkUrl !== null) {
              this.ReadPyCode(
                this.curriculumMaterial.exampleWorkUrl,
                (res) => {
                  console.log('正确代码')
                  console.log(res)
                  sessionStorage.setItem('py_exam_code', res)

                  this.project_url =
                    '/python/teachpy_v2?mode=8&type=1&title=' +
                    this.curriculumMaterial.title
                }
              )
            } else {
              this.project_url =
                '/python/teachpy_v2?mode=9&type=1&title=' +
                this.curriculumMaterial.title
            }

            this.drawer = true
          } else if (cmd == '2') {
            console.log('授课模板')

            if (this.curriculumMaterial.teachTemplateUrl !== null) {
              this.ReadPyCode(
                this.curriculumMaterial.teachTemplateUrl,
                (res) => {
                  console.log('授课模板代码')
                  console.log(res)
                  sessionStorage.setItem('py_exam_code', res)
                  this.project_url =
                    '/python/teachpy_v2?mode=8&type=1&title=' +
                    this.curriculumMaterial.title
                }
              )
            } else {
              this.project_url =
                '/python/teachpy_v2?mode=9&type=1&title=' +
                this.curriculumMaterial.title
            }

            this.drawer = true
          } else if (cmd == '3') {
            console.log('作业模板')
            if (this.curriculumMaterial.homeTemplateUrl !== null) {
              this.ReadPyCode(
                this.curriculumMaterial.homeTemplateUrl,
                (res) => {
                  console.log('作业模板代码')
                  console.log(res)
                  sessionStorage.setItem('py_exam_code', res)
                  this.project_url =
                    '/python/teachpy_v2?mode=8&type=1&title=' +
                    this.curriculumMaterial.title
                }
              )
            } else {
              this.project_url =
                '/python/teachpy_v2?mode=9&type=1&title=' +
                this.curriculumMaterial.title
            }

            this.drawer = true
          }
        } else {
          if (cmd == '1') {
            console.log('PY-课堂成果')

            if (localStorage.getItem('current_py_version') == 'v2') {
              this.project_url =
                '/python/teachpy_v2?mode=1&type=1&title=' +
                this.curriculumMaterial.title
            } else if (localStorage.getItem('current_py_version') == 'v1') {
              this.project_url =
                '/python/teachpy?mode=1&type=1&title=' +
                this.curriculumMaterial.title
            } else {
              this.project_url =
                '/python/teachpy_v2?mode=1&type=1&title=' +
                this.curriculumMaterial.title
            }

            this.$store.commit(
              'SET_EXAM_WORK_URL',
              this.curriculumMaterial.exampleWorkUrl || ''
            )
            this.$store.commit(
              'SET_HOME_TEMPLATE_URL',
              this.curriculumMaterial.homeTemplateUrl || ''
            )
            this.drawer = true
          } else if (cmd == '2' || cmd == '3') {
            console.log('授课模板')

            if (localStorage.getItem('current_py_version') == 'v2') {
              this.project_url =
                '/python/teachpy_v2?mode=1&type=2&title=' +
                this.curriculumMaterial.title
            } else if (localStorage.getItem('current_py_version') == 'v1') {
              this.project_url =
                '/python/teachpy?mode=1&type=2&title=' +
                this.curriculumMaterial.title
            } else {
              this.project_url =
                '/python/teachpy_v2?mode=1&type=2&title=' +
                this.curriculumMaterial.title
            }

            this.$store.commit(
              'SET_TEACH_TEMPLATE_URL',
              this.curriculumMaterial.teachTemplateUrl || ''
            )
            this.$store.commit(
              'SET_HOME_TEMPLATE_URL',
              this.curriculumMaterial.homeTemplateUrl || ''
            )
            this.drawer = true
          }
        }
      }

      if (cmd == '4') {
        console.log('观看学生讲义')
        this.dialogVisible = true

        if (!this.curriculumMaterial.eduId) {
          console.log('平台讲义')

          this.stu_note_url = this.curriculumMaterial.stuNoteUrl
        } else {
          console.log('校区讲义')

          this.stu_note_url = JSON.parse(
            this.curriculumMaterial.stuNoteUrl
          )[0].url
        }
      }

      if (cmd == '5') {
        this.dialogVisible1 = true
      }
    },

    DownloadFile() {
      console.log('下载附加资料')
      window.open(this.curriculumMaterial.otherMaterialUrl, '_blank')
    },
    DownloadFile1(url) {
      let url1 = url
      let url2 = url1.replace(
        'steamfun.oss-cn-zhangjiakou.aliyuncs.com',
        'wuge.steam.fun'
      )
      console.log(url2)

      window.open(url2, '_blank')
    },

    //获得讲次数据
    getPrepareCurrculumMaterial(cb) {
      getPrepareCurrculumMaterial({
        currMatId: this.curriculumMaterial.id,
        tchPlanId: this.tchPlanId,
      }).then((res) => {
        console.log('备授课返回的课程信息')
        console.log(res)
        cb(res.tchPlanInfo)
      })
    },

    //获得老师课程作品

    getTchLesson(cb) {
      if (this.tchPlanId) {
        getTchLesson({
          tchPlanId: this.tchPlanId,
        }).then((res) => {
          console.log('查询老师课堂作品')
          console.log(res)
          cb(res.tchLessonWork)
        })
      } else {
        getTchLesson({
          lessonId: this.curriculumMaterial.id,
        }).then((res) => {
          console.log('查询老师备课作品')
          console.log(res)
          cb(res.tchLessonWork)
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/ .container1 .el-drawer__body {
  overflow: hidden;
}

.container {
  padding-top: 15px;
  padding-right: 15px;

  .course-left {
    height: calc(100vh - 136px);
    display: flex;
    flex-flow: column;
    background: white;

    .course-left-ppt {
      flex: 6;

      .course-view {
        width: 100%;
        height: calc(100vh - 240px);

        border: 2px solid #ccc;
      }
    }

    .course-left-comment {
      flex: 1;

      display: flex;
      flex-flow: column;

      .course-left-comment-title {
        padding-top: 15px;
        flex: 1;
        font-weight: 500;
      }

      .course-left-comment-content {
        flex: 1;
      }
    }
  }

  .course-right {
    height: calc(100vh - 136px);
    display: flex;
    flex-flow: column;
    background: white;

    .course-right-video {
      flex: 1;

      .course-right-video-title {
        padding-bottom: 10px;
        font-weight: 500;
      }

      .course-right-video-desc {
        .coursevideo {
          width: 100%;
          border: 2px solid #dee2e9;
          object-fit: fill;
        }
      }
    }

    .course-right-video1 {
      flex: 2;

      .course-right-video1-title {
        padding: 10px;
        font-weight: 500;
      }

      .course-right-video1-wrapper {
        height: calc((100vh - 81px) / 2 + 50px);
        overflow-y: auto;
        // overflow-x: hidden;
      }

      .videolist {
        padding-bottom: 10px;
      }

      .course-right-video1-desc {
        .coursevideo1 {
          width: 100%;
          border: 2px solid #dee2e9;
          object-fit: fill;
        }
      }
    }
  }
}
</style>

<style>
.container .el-drawer__header {
  margin-bottom: 0px;
  padding: 0px;
  font-weight: bold;
  border-bottom: 0px;
  background: #f9f9f9;
  text-align: center;
}

.el-drawer__header span:focus {
  outline: 0 !important;
}
</style>
